/**
 * Should be added to entities for which help lines outer measurements should be displayed
 */
class HelpLinesOuterMeasurementsComponent {
    constructor() {
        this.typeId = HelpLinesOuterMeasurementsComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = false;
    }
    eq() {
        return true;
    }
}
HelpLinesOuterMeasurementsComponent.id = 2056;
export default HelpLinesOuterMeasurementsComponent;
//# sourceMappingURL=HelpLinesOuterMeasurementsComponent.js.map